<!--
  Generated template for the NotificationMainPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header>
	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-back-button defaultHref="/" (click)="navCtrl.back()"></ion-back-button>
		</ion-buttons>
		<ion-title>
			{{'MYSPORT_NEWS_TITLE' | translate}}
		</ion-title>
	</ion-toolbar>
</ion-header>

<ion-content>
	<ion-list>
		<ion-item *ngFor="let item of news; let i = index" class="notification-item" (click)="openDetails(item.id)">
			<ion-label>
				<h3>{{ item.title }}</h3>
				<p class="small">{{ item.formattedDate }}</p>
			</ion-label>
			<ion-thumbnail slot="end" class="notification-item-thumbnail">
				<img [src]="item.imgLink" />
			</ion-thumbnail>
		</ion-item>
		<!-- <ion-item *ngFor="let item of news;let i=index" class="notification-item" (click)="openDetails(item.id)">
			<h3>{{item.title}}</h3>
			<span class="small">{{item.formattedDate}}</span>
			<span item-end class="notification-item-thumbnail" [style.background-image]="'url('+item.imgLink+')'">
			</span>
		</ion-item> -->

	</ion-list>
	<div class="ion-padding-top" *ngIf="!news || news.length === 0">
		<p class="ion-text-small ion-text-center">{{ 'GLOBAL_NO_RESULTS' | translate }}</p>
	</div>
	<ion-infinite-scroll
		*ngIf="news.length % 25 === 0 && news.length !== 0"
		(ionInfinite)="loadNextPage($event)">
		<ion-infinite-scroll-content
			loadingSpinner="bubbles"
			loadingText="{{ 'GLOBAL_SEARCH_LOADING_MORE' | translate }}">
		</ion-infinite-scroll-content>
	</ion-infinite-scroll>
</ion-content>